import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { mixpanelEvents, useTrackEvent } from '../../utils/mixpanel';
import { makeAPIRequestReactQuery } from '../api';
import { endpoints } from '../endpoints';

import type { GetInsightsProviderRequest, TProviderTreatment } from './types';

export const useGetClinicalProviderInsightsData = (
  options: GetInsightsProviderRequest,
) => {
  const { providerId, practiceId, start, end, shouldUseMockData } = options;
  const { primaryOrganizationId: orgId } = useSelector(
    (state: any) => state.login.user,
  );
  const { trackEvent } = useTrackEvent();

  const benchmarkType = `recommendations`;
  const insightsApiPath = `/${endpoints.videaInsights}/${orgId}/${benchmarkType}/${providerId}`;

  return useQuery<TProviderTreatment[]>({
    queryKey: [insightsApiPath, practiceId, start, end, shouldUseMockData],
    queryFn: async () => {
      const startTime = performance.now();
      const response = await makeAPIRequestReactQuery<TProviderTreatment[]>(
        insightsApiPath,
        {
          start,
          end,
          practiceId,
          returnSampleResponse: shouldUseMockData,
        },
        'get',
        {
          headers: {
            Org: orgId,
          },
        },
      );

      const loadTime = performance.now() - startTime;
      trackEvent(mixpanelEvents.insightsViewLoad, {
        loadTime,
        organizationId: orgId,
        practiceId,
        dashboard: 'CLINICAL',
        drilldown: true,
        providerId,
      });

      return response.map((treatment) => ({
        ...treatment,
        pmsProviderId: providerId,
      }));
    },
    enabled: providerId !== undefined,
  });
};
